import {Dispatch} from 'redux';

import Types from '../Types';

import AppState from '../../reducers/AppState';

import indexGenerics, {Params as BaseParams} from '../generics/index';

import IllustrationUsageHistory from '../../../domain/entities/IllustrationUsageHistory';
import PaginatedResult from '../../../domain/results/PaginatedResult';

import NetIllustrationUsageHistoriesRepository from '../../../data/repositories/writer/NetIllustrationUsageHistoriesRepository';

const types = {
  failure: Types.IndexIllustrationUsageHistoriesFailure,
  request: Types.IndexIllustrationUsageHistoriesRequest,
  success: Types.IndexIllustrationUsageHistoriesSuccess,
};

export interface Params extends BaseParams {
  storyId: number;
}

export default function action(
  params: Params,
): (
  dispatch: Dispatch<any>,
  getState: () => AppState,
) => Promise<PaginatedResult<IllustrationUsageHistory>> {
  return indexGenerics(
    new NetIllustrationUsageHistoriesRepository(),
    types,
    params,
  );
}
